/* @flow */

import React, { useEffect } from "react";
import cn from "classnames";
import { useTranslate } from "@awardit/react-use-translate";
import { useLocation } from "react-router";
import usePrevious from "helpers/use-previous";
import Nav from "./Nav";
import { QuoteData, CmsBlockData } from "data";
import { useData } from "crustate/react";
import { MODE } from "state/view-mode";
import { useUi } from "helpers/ui";
import SystemMessages from "components/SystemMessages";
import { NotificationBar } from "@crossroads/ui-components";

import styles from "./styles.scss";

type Props = {
  showMiniBanner: boolean,
};

const AppHeader = ({
  showMiniBanner,
}: Props): React$Node => {
  const location = useLocation();
  const t = useTranslate();
  const { setHamburgerOpen, setSubNavOpen, setViewMode } = useUi();
  const quoteData = useData(QuoteData);
  const miniBannerData = useData(CmsBlockData);
  const prevQuoteData = usePrevious(quoteData);
  const onCheckout = (location ? location.pathname : "").includes("checkout");

  // Open mini cart when adding to cart
  useEffect(() => {
    if (
      location.pathname === t("URL.CHECKOUT_CART") ||
      !prevQuoteData ||
      quoteData.state !== "LOADED" ||
      prevQuoteData.state !== "ADDING_ITEM"
    ) {
      return;
    }

    const count = quoteData.data.items.reduce((a, { qty }) => a + qty, 0);
    const prevCount = prevQuoteData.data.items.reduce((a, { qty }) => a + qty, 0);

    if (count > prevCount) {
      setViewMode(MODE.CART);
      setSubNavOpen(false);
      setHamburgerOpen(false);
    }
  }, [setViewMode, prevQuoteData, quoteData, location, setSubNavOpen, setHamburgerOpen]);

  return (
    <header className={cn(styles.block, { [styles.onCheckout]: onCheckout })}>
      <SystemMessages />
      <Nav onCheckout={onCheckout} />
      {miniBannerData.state === "LOADED" && showMiniBanner && (
        <NotificationBar
          closeBtnTitle={t("NOTIFICATIONBAR.CLOSE")}
          className={styles.miniBanner}
          text={miniBannerData.data?.content}
          onClose={() => {}}
        />
      )}
    </header>
  );
};

export default AppHeader;
